import React, {
  FC, useEffect, useRef,
} from 'react';
import { v4 as uuid } from 'uuid';
import { RowLeft } from '../Styles';
import OptionButton from '../components/Button/OptionButton';
import LeftToRight from '../components/Animation/LeftToRight';
import RobotReply from '../components/Reply/RobotReply';
import { getWindowWidth, lang } from '../../../../../lib/utils/utils';
import { addSystemLog } from '../../../../../lib/SystemLogUtils';
import { getFoodifoxDataLazy, updateFoodifoxData } from '../../../../../lib/axios/FoodifoxDataAPI';
import TempFieldUtils from '../../../../../lib/TempFieldUtils';
import RobotLoading from '../components/Loading/RobotLoading';
import Q1 from '../Q1';
import Q9 from '../Q9';
import Q12 from '../Q12';
import UserReply from '../components/Reply/UserReply';
import Q0 from '../Q0';

/**
 * 开门成功
 */
const Q7: FC<Props> = ({
  boxList,
  addElement,
  setTargetPage,
  cabId,
  deviceCode,
  h5Platform,
  loadingFlowId,
  needOpenLock,
  sessionId,
  enterPhoneNumber,
}) => {
  // 检查当前柜子有没有订单
  const [checkCabHasOrder] = getFoodifoxDataLazy<{ status: boolean }>('/fox3PDAi/checkHasOrder');
  // 创建离线二维码内容
  const [getOfflineQrCode] = getFoodifoxDataLazy<{ cabId: number; qrCode: string; boxNumber: string }[]>('/fox3PDAi/createOfflineQrCode');
  // 开锁
  const [openLock] = getFoodifoxDataLazy<boolean>('/fox3PDAi/boxOpenLock');
  // 更新订单
  const [updateOrder] = updateFoodifoxData('/fox3PDAi/updateOrder');

  const openBoxNumbers: { cabId: number; boxNumber: string }[] = [];
  const option1 = { zhValue: '是的，需要', enValue: 'Yes' };
  const option2 = { zhValue: '结束对话', enValue: 'No' };
  // 开门失败的柜门集合
  const openFailBoxes = useRef<{ cabId: number; boxNumber: string }[]>([]);

  /**
   * 检测是否还有订单
   */
  const checkHasOrder = () => {
    const loadingFlowId = uuid();
    addElement(
      <RowLeft>
        <RobotLoading flowId={loadingFlowId} />
      </RowLeft>
    );

    checkCabHasOrder({
      param: {
        useCabId: cabId,
      },
      onError() {
        addElement(
          <Q12 />
        );
      },
      onCompleted({ status }) {
        setTimeout(() => {
          // 隐藏loading
          TempFieldUtils.aiFlowIds.push(loadingFlowId);
        }, 2000);
        setTimeout(() => {
          // 隐藏loading
          if (status) {
            addElement(
              <Q0
                addElement={addElement}
                cabId={cabId}
                deviceCode={deviceCode}
                enterPhoneNumber={enterPhoneNumber}
                setTargetPage={() => {
                  setTargetPage('support');
                }}
              />,
            );
          }
          else {
            addElement(
              <Q12 />
            );
          }
        }, 2200);
      }
    });
  };

  useEffect(() => {
    openBox(0);
  }, []);

  /**
   * 隐藏loading
   */
  const hideLoading = () => {
    if (loadingFlowId) {
      // 隐藏loading
      TempFieldUtils.aiFlowIds.push(loadingFlowId);
      TempFieldUtils.aiFlowIds.push(...TempFieldUtils.aiRetainLoadingIds);
      TempFieldUtils.aiRetainLoadingIds = [];
    }
  };

  /**
   * 创建离线二维码，并跳转到Q9
   * @param openFailBoxes
   */
  const createOfflineQrCode = (openFailBoxes: { cabId: number; boxNumber: string }[]) => {
    getOfflineQrCode({
      param: {
        // 开门失败柜门号集合
        boxNumberCabList: openFailBoxes,
      },
      onError() {
        initPage();
      },
      onCompleted(results) {
        const boxes: { cabId: number; boxNumber: string }[] = [];
        results.map(({ cabId, boxNumber }) => {
          boxes.push({ cabId, boxNumber });
        });

        hideLoading();
        addElement(
          <Q9
            cabId={cabId}
            boxList={boxes}
            boxOfflineCode={results}
            addElement={addElement}
            setTargetPage={setTargetPage}
            h5Platform={h5Platform}
            deviceCode={deviceCode}
            sessionId={sessionId}
            enterPhoneNumber={enterPhoneNumber}
          />
        );
      },
    });
  };

  /**
   * 开门
   * @param index 柜门下标，从0开始
   * @param tryCount 开门失败后，尝试再次开门的次数
   */
  const openBox = (index: number, tryCount?: number) => {
    if (!boxList[index]) {
      // 如果开门失败时，需要创建离线二维码
      if (openFailBoxes.current.length > 0) {
        createOfflineQrCode(openFailBoxes.current);
      }
      else {
        initPage();
      }
      return;
    }

    const box = boxList[index];
    // 不需要开锁
    if (needOpenLock === false) {
      updateOrder({
        param: {
          boxNumberCabList: [{ ...box, deviceCode, sessionId }],
        },
        onCompleted() {
          openBoxNumbers.push(box);
          openBox(index += 1);
        },
      });
    }
    else {
      openLock({
        param: {
          cabId: box.cabId,
          boxNumber: box.boxNumber,
        },
        onCompleted(status) {
          if (status) {
            updateOrder({
              param: {
                boxNumberCabList: [{ ...box, deviceCode, sessionId }],
              },
              onCompleted() {
                openBoxNumbers.push(box);
                openBox(index += 1);
              },
            });
          }
          else {
            if (tryCount != null && tryCount > 1) {
              // 开门失败柜门号加入到集合
              openFailBoxes.current.push(box);
              // 继续开下一个柜门
              openBox(index += 1);
            }
            else {
              setTimeout(() => {
                openBox(index, tryCount == null ? 1 : tryCount + 1);
              }, 3000);
            }
          }
        },
      });
    }
  };

  const initPage = () => {
    // 隐藏loading
    hideLoading();

    // 流程ID
    const flowId = uuid();
    addElement(
      <LeftToRight flowId={flowId}>
        <RowLeft style={{ alignItems: 'center', marginTop: 25 }}>
          <RobotReply
            style={{ maxWidth: 'unset', width: lang(getWindowWidth() * 0.59, getWindowWidth() * 0.58) }}
            langZh={(
              <>
                <span style={{ fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600 }}>
                  {openBoxNumbers.map(({ boxNumber }) => {
                    return '柜门#' + boxNumber;
                  }).join('，')}
                </span> 已经打开。请取走您的食物并关闭柜门。祝您用餐愉快!请问是否还需 要其他帮助?
              </>
            )}
            langEn={(
              <>
                <span style={{ fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold' }}>
                  {openBoxNumbers.map(({ boxNumber }) => {
                    return 'Door#' + boxNumber;
                  }).join(',')}
                </span> has opened. Please pick-up your delivery and close the door. <br />Can I help with anything else?
              </>
            )}
          />
        </RowLeft>
      </LeftToRight>
    );

    // 机器人回复日志
    addSystemLog(cabId, deviceCode, h5Platform + '', 'Q7 - bot: ' + openBoxNumbers.map(({ boxNumber }) => 'Door#' + boxNumber).join(',') + ' is open. Please take your meal and close the door. Do you need any other assistance today?', sessionId);

    setTimeout(() => {
      addElement(
        <LeftToRight flowId={flowId}>
          <RowLeft>
            <OptionButton
              langZh={option1.zhValue}
              langEn={option1.enValue}
              flowId={flowId}
              style={{ width: 110 }}
              callback={() => {
                addSystemLog(cabId, deviceCode, h5Platform + '', 'Q7 - user: ' + option1.enValue, sessionId);
                addElement(
                  <UserReply
                    langZh={option1.zhValue}
                    langEn={option1.enValue}
                  />
                );

                // 检测是否还有订单
                checkHasOrder();
              }}
            />
          </RowLeft>
          <RowLeft>
            <OptionButton
              langZh={option2.zhValue}
              langEn={option2.enValue}
              flowId={flowId}
              style={{ width: 110 }}
              callback={() => {
                addSystemLog(cabId, deviceCode, h5Platform + '', 'Q7 - user: ' + option2.enValue, sessionId);
                setTargetPage('support');
              }}
            />
          </RowLeft>
        </LeftToRight>
      );
    }, 400);
  };

  return (
    <></>
  );
};

export interface Props {
  boxList: { cabId: number; boxNumber: string }[];
  addElement: (elements: any) => void;
  setTargetPage: (targetPage: string) => void;
  cabId: number;
  deviceCode: string;
  h5Platform: number;
  loadingFlowId?: string;
  needOpenLock?: boolean;
  sessionId: string;
  // 进入AI对话的用户手机号
  enterPhoneNumber: string;
}

export default Q7;
